import { RetentionSentView } from "./retention-sent-view.tsx";
import overlayStyles from "../shared/offboarding-page-overlay.module.css";

export interface RetentionSentModalProps {
    open: boolean;
    updatedAt?: string | null;
    loading?: boolean;
    onResign: () => void;
}

/** Page-scoped retention confirmation dialog. */
export function RetentionSentModal({
    open,
    updatedAt,
    loading = false,
    onResign,
}: RetentionSentModalProps) {
    if (!open) return null;

    return (
      <div className={overlayStyles.overlay} role="presentation">
        <div
          className={overlayStyles.dialog}
          role="dialog"
          aria-modal="true"
          aria-label="Retention request sent"
          onClick={(e) => e.stopPropagation()}
        >
          <RetentionSentView
            loading={loading}
            onResign={onResign}
            embedded
             updatedAt={updatedAt}
          />
        </div>
      </div>
    );
}
